/* assets/alb-wasserqualitaet-check.js · ALB Horizon Rebuild
   Wasserqualität-Check („Meine Wasserqualität prüfen“): PLZ eingeben → Ort und Wasserhärte aus den
   Wasserhärte-Daten (assets/alb-wasserhaerte-<land>-<ziffer>.json, hardness.sql Stand 10/2026) plus
   der zuständige Wasserversorger mit Link zur offiziellen Trinkwasseranalyse und den dort
   veröffentlichten Kernwerten (assets/alb-versorger-<land>-<ziffer>.json: kuratiert aus den Versorger-Seiten plus
   Zuordnung über das BDEW-Wasserportal für die übrigen PLZ, Aufbereitung wasserhaerte-plz/versorger/build_versorger.py).
   Zuordnung: erst PLZ-Liste (Overrides + BDEW), sonst Ortsname (optional auf PLZ-Präfixe begrenzt).
   Datenschutz: Die PLZ verlässt den Browser nicht. An GA4 gehen nur Ergebnisart, Land, Härtebereich
   und ob ein Versorger bekannt war, und erst nach Analyse-Einwilligung (Muster alb-wasserhaerte-check.js). */
(function () {
  'use strict';
  if (customElements.get('alb-wasserqualitaet-check')) return;

  var GA4_ID = 'G-BKZBE7XSL1';

  /* Grenz- und Richtwerte für das Trinkwasser in Deutschland (TrinkwV 2023) und Österreich (TWV, gleiche EU-Basis).
     max = Grenzwert; bei pH ein Bereich. Blei: 10 µg/l, ab 12.01.2028 5 µg/l. Calcium/Magnesium: Mineralstoffe ohne Grenzwert. */
  var WERTE = [
    { k: 'nitrat_mg_l',    label: 'Nitrat',    einheit: 'mg/l', max: 50 },
    { k: 'ph',             label: 'pH-Wert',   einheit: '',     min: 6.5, max: 9.5, bereich: true },
    { k: 'chlorid_mg_l',   label: 'Chlorid',   einheit: 'mg/l', max: 250 },
    { k: 'sulfat_mg_l',    label: 'Sulfat',    einheit: 'mg/l', max: 250 },
    { k: 'natrium_mg_l',   label: 'Natrium',   einheit: 'mg/l', max: 200 },
    { k: 'calcium_mg_l',   label: 'Calcium',   einheit: 'mg/l' },
    { k: 'magnesium_mg_l', label: 'Magnesium', einheit: 'mg/l' },
    { k: 'uran_ug_l',      label: 'Uran',      einheit: 'µg/l', max: 10 },
    { k: 'blei_ug_l',      label: 'Blei',      einheit: 'µg/l', max: 10 },
    { k: 'pfas20_ug_l',    label: 'PFAS-20',   einheit: 'µg/l', max: 0.1 }
  ];

  function albGa4(eventName, params) {
    var p = { send_to: GA4_ID };
    for (var k in params) {
      if (Object.prototype.hasOwnProperty.call(params, k) && params[k] !== undefined && params[k] !== '') p[k] = params[k];
    }
    if (typeof window.gtag === 'function') { window.gtag('event', eventName, p); return; }
    window.dataLayer = window.dataLayer || [];
    (function () { window.dataLayer.push(arguments); })('event', eventName, p);
  }

  function mitAnalyseEinwilligung(los) {
    var S = window.Shopify;
    var pruefen = function () {
      var cp = S && S.customerPrivacy;
      if (cp && typeof cp.analyticsProcessingAllowed === 'function' && cp.analyticsProcessingAllowed()) { los(); return; }
      var beiEntscheidung = function (e) {
        if (!(e && e.detail && e.detail.analyticsAllowed)) return;
        document.removeEventListener('visitorConsentCollected', beiEntscheidung);
        los();
      };
      document.addEventListener('visitorConsentCollected', beiEntscheidung);
    };
    if (S && S.customerPrivacy) { pruefen(); return; }
    if (S && typeof S.loadFeatures === 'function') {
      S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () { pruefen(); });
      return;
    }
    pruefen();
  }

  function bereich(wert) { return wert <= 8 ? 'weich' : (wert <= 14 ? 'mittel' : 'hart'); }
  function zahl(x, stellen) {
    return Number(x).toLocaleString('de-DE', { maximumFractionDigits: stellen === undefined ? 1 : stellen });
  }
  function esc(t) { var d = document.createElement('div'); d.textContent = String(t == null ? '' : t); return d.innerHTML; }
  function norm(t) {
    return String(t || '').toLowerCase()
      .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
      .replace(/[^a-z0-9]+/g, ' ').trim();
  }
  function telHref(t) { return 'tel:' + String(t).replace(/[^+0-9]/g, ''); }

  var cache = {};
  var warteschlange = [], einwilligungAngefragt = false, einwilligungErteilt = false;

  class AlbWasserqualitaetCheck extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      try { this.urls = JSON.parse(this.getAttribute('data-urls') || '{}'); } catch (e) { this.urls = {}; }
      try { this.texte = JSON.parse(this.querySelector('script[data-texte]').textContent); } catch (e) { this.texte = {}; }
      this.form = this.querySelector('form');
      this.feld = this.querySelector('input[name="plz"]');
      this.knopf = this.querySelector('button[type="submit"]');
      this.meldung = this.querySelector('[data-meldung]');
      this.ergebnis = this.querySelector('[data-ergebnis]');
      if (!this.form || !this.feld || !this.ergebnis) return;
      var self = this;
      this.feld.addEventListener('input', function () {
        var sauber = self.feld.value.replace(/\D/g, '').slice(0, 5);
        if (sauber !== self.feld.value) self.feld.value = sauber;
        if (self.meldung) self.meldung.hidden = true;
      });
      this.form.addEventListener('submit', function (e) { e.preventDefault(); self.suchen(); });
      // Direktstart per ?plz=72336 (z. B. aus Newsletter-Links), ohne die PLZ zu speichern
      try {
        var q = new URLSearchParams(location.search).get('plz');
        if (q && /^\d{4,5}$/.test(q)) { this.feld.value = q; this.suchen(); }
      } catch (e) {}
    }

    melde(text) {
      if (!this.meldung) return;
      this.meldung.textContent = text;
      this.meldung.hidden = false;
    }

    laden(schluessel) {
      if (cache[schluessel]) return cache[schluessel];
      var url = this.urls[schluessel];
      if (!url) return Promise.resolve(null);
      cache[schluessel] = fetch(url, { credentials: 'omit' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .catch(function (err) { delete cache[schluessel]; throw err; });
      return cache[schluessel];
    }

    suchen() {
      var plz = this.feld.value.replace(/\D/g, '');
      var t = this.texte;
      if (plz.length !== 5 && plz.length !== 4) {
        this.melde(t.ungueltig || 'Bitte gib eine Postleitzahl mit 5 Ziffern ein (Österreich 4 Ziffern).');
        this.ergebnis.hidden = true;
        this.zeigeEmpfehlung(null);
        this.zaehle('ungueltig');
        return;
      }
      var land = plz.length === 5 ? 'de' : 'at';
      var self = this;
      if (this.knopf) { this.knopf.disabled = true; this.knopf.setAttribute('aria-busy', 'true'); }
      Promise.all([this.laden(land + '-' + plz[0]), this.laden('v-' + land + '-' + plz[0]).catch(function () { return null; })])
        .then(function (res) {
          var daten = res[0], vers = res[1];
          var e = daten && daten.d && daten.d[plz];
          var v = self.versorgerFuer(vers, plz, e ? e[0] : '');
          if (!e && !v) {
            self.zeigeKeinTreffer(plz, land);
            self.zaehle('kein_treffer', land, undefined, false);
            return;
          }
          self.zeige(plz, land, e, v, vers);
          self.zaehle('treffer', land, e ? bereich(e[1]) : undefined, !!v);
        })
        .catch(function () {
          self.melde(t.fehler || 'Die Werte konnten gerade nicht geladen werden. Bitte versuche es gleich noch einmal.');
        })
        .then(function () {
          if (self.knopf) { self.knopf.disabled = false; self.knopf.removeAttribute('aria-busy'); }
        });
    }

    /* Versorger-Zuordnung: 1. PLZ-Liste, 2. Ortsname (mit optionalen PLZ-Präfixen), sonst null */
    versorgerFuer(vers, plz, ort) {
      if (!vers || !vers.versorger) return null;
      var id = vers.plz && vers.plz[plz];
      if (!id && ort && vers.orte) {
        var eintrag = vers.orte[norm(ort)];
        if (typeof eintrag === 'string') id = eintrag;
        else if (eintrag && eintrag.id) {
          var ok = !eintrag.px || eintrag.px.some(function (p) { return plz.indexOf(p) === 0; });
          if (ok) id = eintrag.id;
        }
      }
      var v = id && vers.versorger[id];
      return v ? Object.assign({ id: id }, v) : null;
    }

    sucheLink(ort, land) {
      var q = 'Trinkwasseranalyse ' + ort;
      return 'https://www.google.com/search?q=' + encodeURIComponent(q) + (land === 'at' ? '&gl=at' : '&gl=de');
    }

    zeigeKeinTreffer(plz, land) {
      var t = this.texte;
      this.ergebnis.innerHTML =
        '<div class="alb-wq-karte alb-wq-karte--leer">' +
          '<p class="alb-wq-kicker">' + esc(t.kicker || 'Dein Wasserversorger') + '</p>' +
          '<p class="alb-wq-ort">' + esc(plz) + '</p>' +
          '<p class="alb-wq-text">' + esc(t.kein_treffer || 'Für diese Postleitzahl haben wir keine Daten.') + '</p>' +
          this.soFindest(null, land) +
        '</div>';
      this.ergebnis.hidden = false;
      this.zeigeEmpfehlung(null);
      this.fokus();
    }

    /* Hilfe-Block „So findest du deinen Versorger“ (bei unbekanntem Versorger) */
    soFindest(ort, land) {
      var t = this.texte;
      var html = '<div class="alb-wq-hilfe">' +
        (t.hilfe_titel ? '<p class="alb-wq-hilfe-titel">' + esc(t.hilfe_titel) + '</p>' : '') +
        (t.hilfe_text ? '<div class="alb-wq-hilfe-text">' + t.hilfe_text + '</div>' : '');
      if (ort) {
        var label = (t.suche_label || 'Trinkwasseranalyse für {ort} suchen').replace('{ort}', ort);
        html += '<a class="alb-btn alb-btn--outline alb-wq-suche" href="' + this.sucheLink(ort, land) + '" target="_blank" rel="noopener">' + esc(label) + '</a>';
      }
      return html + '</div>';
    }

    /* Karte 1: Versorger */
    versorgerKarte(v, ort, land) {
      var t = this.texte;
      if (!v) {
        return '<div class="alb-wq-block alb-wq-block--versorger">' +
          '<p class="alb-wq-block-titel">' + esc(t.label_versorger || 'Dein Wasserversorger') + '</p>' +
          '<p class="alb-wq-text">' + esc(t.kein_versorger || 'Für diesen Ort haben wir den Versorger noch nicht erfasst.') + '</p>' +
          this.soFindest(ort, land) +
          '</div>';
      }
      var zeilen = '';
      if (v.tel) zeilen += '<li><span>' + esc(t.label_hotline || 'Kundenservice') + '</span><a href="' + telHref(v.tel) + '">' + esc(v.tel) + '</a></li>';
      if (v.st) zeilen += '<li><span>' + esc(t.label_stand || 'Stand der Analyse') + '</span><span>' + esc(v.st) + '</span></li>';
      var buttons = '';
      if (v.a) {
        var aLabel = v.art === 'abfrage' ? (t.btn_abfrage || 'Wasserwerte für deine Adresse abfragen')
          : (v.art === 'pdf' ? (t.btn_pdf || 'Offizielle Trinkwasseranalyse (PDF)') : (t.btn_analyse || 'Offizielle Trinkwasseranalyse ansehen'));
        buttons += '<a class="alb-btn alb-wq-btn" href="' + esc(v.a) + '" target="_blank" rel="noopener">' + esc(aLabel) + '</a>';
      }
      if (v.w) buttons += '<a class="alb-btn alb-btn--outline alb-wq-btn" href="' + esc(v.w) + '" target="_blank" rel="noopener">' + esc(t.btn_website || 'Zur Website des Versorgers') + '</a>';
      var quelle = '';
      if (v.src === 'bdew' && t.hinweis_bdew) {
        quelle = '<p class="alb-wq-versorger-quelle">' + esc(t.hinweis_bdew) + ' <a href="https://www.wasserportal.info/" target="_blank" rel="noopener">' + esc(t.label_bdew || 'Zum Wasserportal') + '</a></p>';
      }
      return '<div class="alb-wq-block alb-wq-block--versorger">' +
        '<p class="alb-wq-block-titel">' + esc(t.label_versorger || 'Dein Wasserversorger') + '</p>' +
        '<p class="alb-wq-versorger-name">' + esc(v.n) + (v.k && v.k.length < v.n.length && v.n.indexOf(v.k) === -1 ? ' <span class="alb-wq-versorger-kurz">(' + esc(v.k) + ')</span>' : '') + '</p>' +
        (v.h ? '<p class="alb-wq-versorger-hinweis">' + esc(v.h) + '</p>' : '') +
        (zeilen ? '<ul class="alb-wq-zeilen">' + zeilen + '</ul>' : '') +
        (buttons ? '<div class="alb-wq-buttons">' + buttons + '</div>' : '') +
        quelle +
        '</div>';
    }

    /* Karte 2: Wasserhärte (aus den PLZ-Daten) */
    haerteKarte(e) {
      var t = this.texte;
      if (!e) return '';
      var typ = e[1], lo = e[2], hi = e[3], gruppen = e[4] || [];
      var spanne = hi - lo > 2;
      var b = bereich(typ), bLo = bereich(lo), bHi = bereich(hi);
      var bereichText = spanne && bLo !== bHi ? bLo + ' bis ' + bHi : b;
      var wert = spanne ? zahl(lo) + '–' + zahl(hi) : 'ca. ' + zahl(typ);
      var satz = spanne
        ? (t.satz_spanne || 'Je nach Ortsteil liegt die Härte zwischen {min} und {max} °dH. Das ist {bereich}.')
        : (t.satz_einzeln || 'Das Leitungswasser hat hier etwa {wert} °dH. Das gilt als {bereich}.');
      satz = satz.replace('{min}', zahl(lo)).replace('{max}', zahl(hi)).replace('{wert}', zahl(typ)).replace('{bereich}', '<strong>' + esc(bereichText) + '</strong>');
      var pos = function (x) { return Math.max(0, Math.min(100, x / 30 * 100)); };
      var marke = spanne
        ? '<span class="alb-wq-skala-band" style="left:' + pos(lo) + '%;width:' + Math.max(2, pos(hi) - pos(lo)) + '%"></span>'
        : '<span class="alb-wq-skala-punkt" style="left:' + pos(typ) + '%"></span>';
      var liste = '';
      if (gruppen.length > 1) {
        liste = '<details class="alb-wq-ortsteile"><summary>' + esc(t.ortsteile || 'Werte je Ortsteil') + '</summary><ul>' +
          gruppen.map(function (g) { return '<li><strong>' + zahl(g[0]) + '&nbsp;°dH</strong> ' + esc(g[1]) + '</li>'; }).join('') +
          '</ul></details>';
      }
      return '<div class="alb-wq-block alb-wq-block--haerte alb-wq-block--' + b + '">' +
        '<p class="alb-wq-block-titel">' + esc(t.label_haerte || 'Wasserhärte') + '</p>' +
        '<p class="alb-wq-wert"><span>' + wert + '</span>&nbsp;°dH</p>' +
        '<p class="alb-wq-text">' + satz + '</p>' +
        '<div class="alb-wq-skala" aria-hidden="true">' +
          '<div class="alb-wq-skala-bahn"><span class="alb-wq-zone alb-wq-zone--weich"></span><span class="alb-wq-zone alb-wq-zone--mittel"></span><span class="alb-wq-zone alb-wq-zone--hart"></span>' + marke + '</div>' +
          '<div class="alb-wq-skala-labels"><span>weich</span><span>mittel</span><span>hart</span></div>' +
        '</div>' +
        liste +
        '<div class="alb-wq-bedeutung">' + (t['bedeutung_' + b] || '') + '</div>' +
        '</div>';
    }

    /* Karte 3: offizielle Analysewerte des Versorgers */
    werteKarte(v) {
      var t = this.texte;
      if (!v || !v.wv) return '';
      var wv = v.wv;
      var zeilen = [];
      WERTE.forEach(function (w) {
        var val = wv[w.k];
        if (val === null || val === undefined) return;
        var anzeige, prozent = null, status = '';
        if (Array.isArray(val)) {
          anzeige = zahl(val[0], 2) + '–' + zahl(val[1], 2);
          if (w.max && !w.bereich) prozent = val[1] / w.max * 100;
        } else {
          anzeige = zahl(val, w.k === 'pfas20_ug_l' ? 3 : 2);
          if (w.max && !w.bereich) prozent = val / w.max * 100;
        }
        if (w.bereich) {
          var lo = Array.isArray(val) ? val[0] : val, hi = Array.isArray(val) ? val[1] : val;
          status = (lo >= w.min && hi <= w.max) ? 'ok' : 'ueber';
        } else if (w.max) {
          status = prozent <= 100 ? 'ok' : 'ueber';
        }
        var grenz = w.bereich ? (t.label_bereich || 'zulässig') + ' ' + zahl(w.min) + '–' + zahl(w.max)
          : (w.max ? (t.label_grenzwert || 'Grenzwert') + ' ' + zahl(w.max, 3) + ' ' + w.einheit : (t.label_mineral || 'Mineralstoff, kein Grenzwert'));
        var balken = prozent !== null
          ? '<span class="alb-wq-balken" aria-hidden="true"><span class="alb-wq-balken-fuellung alb-wq-balken-fuellung--' + status + '" style="width:' + Math.max(1, Math.min(100, prozent)) + '%"></span></span>'
          : '';
        var chip = status ? '<span class="alb-wq-chip alb-wq-chip--' + status + '">' + esc(status === 'ok' ? (t.chip_ok || 'eingehalten') : (t.chip_ueber || 'über dem Grenzwert')) + '</span>' : '';
        zeilen.push('<li class="alb-wq-wertzeile">' +
          '<span class="alb-wq-wert-label">' + esc(w.label) + '</span>' +
          '<span class="alb-wq-wert-zahl">' + anzeige + (w.einheit ? '&nbsp;' + esc(w.einheit) : '') + '</span>' +
          '<span class="alb-wq-wert-grenz">' + esc(grenz) + ' ' + chip + '</span>' +
          balken +
          '</li>');
      });
      if (!zeilen.length) return '';
      return '<div class="alb-wq-block alb-wq-block--werte">' +
        '<p class="alb-wq-block-titel">' + esc(t.label_werte || 'Werte aus der offiziellen Analyse') + '</p>' +
        '<ul class="alb-wq-werte">' + zeilen.join('') + '</ul>' +
        (v.z && t.hinweis_zonen ? '<p class="alb-wq-zonen">' + esc(t.hinweis_zonen) + '</p>' : '') +
        (v.q ? '<p class="alb-wq-quelle">' + esc(t.label_quelle || 'Quelle') + ' <a href="' + esc(v.q) + '" target="_blank" rel="noopener">' + esc(v.n) + (v.st ? ', ' + esc(v.st) : '') + '</a></p>' : '') +
        '</div>';
    }

    /* Hinweise, die sich aus den Werten ergeben (nur wenn der Wert vorliegt) */
    hinweise(v) {
      var t = this.texte;
      if (!v || !v.wv) return '';
      var wv = v.wv, items = [];
      if (wv.nitrat_mg_l != null && t.note_nitrat) items.push(t.note_nitrat);
      if ((wv.blei_ug_l != null || wv.uran_ug_l != null) && t.note_schwermetalle) items.push(t.note_schwermetalle);
      if (t.note_hausinstallation) items.push(t.note_hausinstallation);
      if (!items.length) return '';
      return '<div class="alb-wq-block alb-wq-block--notes">' +
        '<p class="alb-wq-block-titel">' + esc(t.label_notes || 'Gut zu wissen') + '</p>' +
        '<ul class="alb-wq-notes">' + items.map(function (x) { return '<li>' + x + '</li>'; }).join('') + '</ul>' +
        '</div>';
    }

    zeige(plz, land, e, v, vers) {
      var t = this.texte;
      var ort = e ? e[0] : (v && v.ort) || '';
      var b = e ? bereich(e[1]) : null;
      this.ergebnis.innerHTML =
        '<div class="alb-wq-karte' + (b ? ' alb-wq-karte--' + b : '') + '">' +
          '<p class="alb-wq-kicker">' + esc(t.kicker || 'Dein Wasser') + '</p>' +
          '<p class="alb-wq-ort">' + esc(plz) + ' ' + esc(ort) + (land === 'at' ? ' <span class="alb-wq-land">(AT)</span>' : '') + '</p>' +
          this.versorgerKarte(v, ort, land) +
          this.haerteKarte(e) +
          this.werteKarte(v) +
          this.hinweise(v) +
          '<p class="alb-wq-hinweis">' + esc(v ? (t.hinweis || '') : (t.hinweis_ohne || t.hinweis || '')) + (v && vers && vers.stand ? ' ' + esc((t.hinweis_stand || 'Datenstand {stand}.').replace('{stand}', vers.stand)) : '') + '</p>' +
        '</div>';
      this.ergebnis.hidden = false;
      this.zeigeEmpfehlung(b);
      this.fokus();
    }

    zeigeEmpfehlung(b) {
      var boxen = this.querySelectorAll('[data-empfehlung]');
      boxen.forEach(function (box) { box.hidden = !(b && box.getAttribute('data-empfehlung') === b); });
    }

    fokus() {
      var karte = this.ergebnis.querySelector('.alb-wq-karte');
      if (!karte) return;
      karte.setAttribute('tabindex', '-1');
      try {
        karte.focus({ preventScroll: true });
        var r = karte.getBoundingClientRect(), vh = window.innerHeight || document.documentElement.clientHeight;
        if (r.top < 0 || r.top > vh * 0.45) karte.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      } catch (e) {}
    }

    zaehle(ergebnis, land, b, versorger) {
      warteschlange.push({ ergebnis: ergebnis, land: land ? land.toUpperCase() : undefined, haertebereich: b, versorger_bekannt: versorger === undefined ? undefined : (versorger ? 'ja' : 'nein') });
      if (einwilligungAngefragt) {
        if (einwilligungErteilt) while (warteschlange.length) albGa4('alb_wasserqualitaet_check', warteschlange.shift());
        return;
      }
      einwilligungAngefragt = true;
      mitAnalyseEinwilligung(function () {
        einwilligungErteilt = true;
        while (warteschlange.length) albGa4('alb_wasserqualitaet_check', warteschlange.shift());
      });
    }
  }

  customElements.define('alb-wasserqualitaet-check', AlbWasserqualitaetCheck);
})();
